<template functional>
    <div>
        <template v-if="props.include">
             <h4 class="text-base  text-dark font-medium">费用包含</h4>
            <div class="whitespace-pre-line text-base mt-2 mb-5" v-html="props.include" />
        </template>
        <template v-if="props.notInclude">
            <h4 class="text-base  text-dark font-medium">费用不含</h4>
            <div class="whitespace-pre-line text-base mt-2" v-html="props.notInclude" />
        </template>
    </div>
</template>
<script>
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
    props: {
        include: String,
        notInclude: String
    },
})
</script>
<style lang="scss" module>

    

</style>